import {domain} from './APIConstant';

export const routeResource={
    image: domain+'/src/image'
}
export const validFileExtension=[
    '.jpg','.png'
]
export const validFileType=[
    'image/jpeg','image/png'
]
export const logoURL = 'https://storage.googleapis.com/maskstore-abf18.appspot.com/1650566427892.png';
export const COVID19_PANEL = 'https://storage.googleapis.com/maskstore-abf18.appspot.com/1651685780216.png';